import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getAccountsData, GET_ACCOUNTS_FAIL } from '../../actions/cloud-account/index';
import { forwardLogin } from '../../actions/login/index';
import CloudAccountList from '../../components/maintenance/CloudAccountList';
import Loading from '../../components/common/Loading';

class CloudAccountListPage extends Component {
  renderList = () => {
    const { loading } = this.props;

    let displayList;
    if (loading) {
      displayList = <Loading loading={loading}></Loading>;
    } else {
      displayList = <CloudAccountList></CloudAccountList>;
    }

    return (
      <div className='custom-list cloud-account-list'>
        {displayList}
      </div>
    )
  }

  componentDidMount() {
    const { idToken, getAccountsData, accounts } = this.props;
    if (accounts.length === 0) {
      if (idToken) {
        getAccountsData(idToken);
      }
    }
  }
  
  componentDidUpdate (prevProps, prevState, snapshot) {
    const { forwardLogin, status, history } = this.props;
    if (prevProps.status !== status) {
      if (status === GET_ACCOUNTS_FAIL) {
        forwardLogin("Connect timeout, please relogin.");
        history.push("/Login");
      }
    }
  }

  render() {
    return this.renderList();
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    idToken: state.logindReducers.idToken,
    status: state.cloudAccountReducers.status,
    accounts: state.cloudAccountReducers.accounts,
    loading: state.cloudAccountReducers.loading
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { forwardLogin, getAccountsData }
)(CloudAccountListPage))
